<template>
<v-card class="d-none d-md-block">
  <router-link class="nolink" :to="`/project/${project.id}/${project.slug}`">
    <v-hover>
      <template v-slot:default="{ hover }">
        
    <v-img :aspect-ratio="16/9" :src="project.thumbnail">
      <v-row class="lightbox white--text pa-2 fill-height">
        <v-fade-transition>
          <v-overlay :absolute="true" :value="true" :opacity="0.6" v-if="hover">
            <v-btn color="primary" >
              <v-icon small>fa-play</v-icon>
            </v-btn>

          </v-overlay>
        </v-fade-transition>
      </v-row>
    </v-img>
  </template>
    </v-hover>
  </router-link>

</v-card>
</template>
<script>
export default {
  props: ['project'],
  name: "",
  data: () => ({

  })
}
</script>
<style lang="scss" scoped>
</style>
